import { resolveBrand, isBrandHost } from '@/shared/branding'

const hostname = window.location.hostname

const brand = resolveBrand(hostname)

export const isBrandedHost = isBrandHost(hostname)

export const useBrand = () => brand

export default brand
